import { useLoanContext } from "@/screens/loans/components/LoanContext"
import { Horizontal, Vertical } from "@/components/standard/BFLayout"
import { Body, H2, H5, Tiny } from "@/components/standard/BFText"
import { View } from "react-native"
import { type ReactNode } from "react"
import { Path, Svg } from "react-native-svg"

function BindingIcon() {
  return (
    <Svg width={16} height={16} viewBox="0 0 16 16" fill="none">
      <Path
        d="M13.886 2.114a2.667 2.667 0 00-3.766-.005l-.97 1.018a.667.667 0 01-.966-.917l.977-1.024a4 4 0 015.657 5.657l-1.025.976a.666.666 0 01-.916-.965l1.017-.97a2.667 2.667 0 00-.008-3.77zM6.85 12.874L5.88 13.89a2.667 2.667 0 01-3.77-3.771l1.017-.97a.667.667 0 00-.917-.966l-1.027.977a4 4 0 005.657 5.657l.976-1.025a.666.666 0 10-.965-.916v-.004zM15.333 10h-2a.667.667 0 100 1.333h2a.667.667 0 100-1.333zM.667 6h2a.667.667 0 000-1.333h-2A.667.667 0 10.667 6zm10 6.667a.667.667 0 00-.667.666v2a.666.666 0 101.333 0v-2a.667.667 0 00-.666-.666zM5.333 3.333A.667.667 0 006 2.667v-2a.667.667 0 00-1.333 0v2a.667.667 0 00.666.666z"
        fill="#000"
      />
    </Svg>
  )
}

function ShieldIcon() {
  return (
    <Svg width={16} height={18} viewBox="0 0 16 18" fill="none">
      <Path
        d="M14.667.667H1.333A1.333 1.333 0 000 2v4.667c0 4.393 2.127 7.056 3.91 8.516 1.922 1.572 3.834 2.105 3.917 2.127a.666.666 0 00.35 0c.084-.022 1.993-.555 3.917-2.127C13.874 13.723 16 11.06 16 6.667V2A1.333 1.333 0 0014.667.667zm0 6c0 3.09-1.139 5.597-3.384 7.452A10.775 10.775 0 018 15.969a10.69 10.69 0 01-3.243-1.818c-2.272-1.858-3.424-4.376-3.424-7.484V2h13.334v4.667zM4.195 9.139a.667.667 0 01.943-.944l1.529 1.53 4.195-4.196a.666.666 0 11.943.943l-4.667 4.667a.669.669 0 01-.943 0l-2-2z"
        fill="#000"
      />
    </Svg>
  )
}

function ScoreIcon() {
  return (
    <Svg width={18} height={18} viewBox="0 0 18 18" fill="none">
      <Path
        d="M16.864 6.977c-.303-.317-.617-.643-.735-.93-.109-.263-.115-.698-.122-1.12-.012-.785-.025-1.673-.643-2.291-.618-.618-1.506-.631-2.29-.643-.423-.007-.858-.013-1.12-.122-.287-.118-.614-.432-.93-.735C10.468.603 9.838 0 9 0S7.532.603 6.977 1.136c-.317.303-.643.617-.93.735-.261.109-.698.115-1.12.122-.785.012-1.673.025-2.291.643-.618.618-.627 1.506-.643 2.29-.007.423-.013.858-.122 1.12-.118.287-.432.614-.735.93C.603 7.532 0 8.162 0 9s.603 1.468 1.136 2.023c.303.317.617.643.735.93.109.263.115.698.122 1.12.012.785.025 1.673.643 2.291.618.618 1.506.631 2.29.643.423.007.858.013 1.12.122.287.118.614.432.93.735C7.532 17.396 8.162 18 9 18s1.468-.604 2.023-1.136c.317-.303.643-.617.93-.735.263-.109.698-.115 1.12-.122.785-.012 1.673-.025 2.291-.643.618-.618.631-1.506.643-2.29.007-.423.013-.858.122-1.12.118-.287.432-.614.735-.93C17.396 10.468 18 9.838 18 9s-.604-1.468-1.136-2.023zm-.928 3.157c-.385.402-.784.817-.995 1.327-.203.49-.212 1.05-.22 1.593-.008.563-.016 1.152-.266 1.4-.25.25-.835.26-1.401.267-.542.008-1.103.017-1.593.22-.51.211-.925.61-1.327.995-.402.384-.813.778-1.134.778-.321 0-.735-.395-1.134-.778-.398-.384-.817-.784-1.327-.995-.49-.203-1.05-.212-1.593-.22-.563-.008-1.152-.016-1.4-.266-.25-.25-.26-.835-.267-1.401-.008-.542-.017-1.103-.22-1.593-.211-.51-.61-.925-.995-1.327C1.68 9.732 1.286 9.32 1.286 9c0-.321.395-.735.778-1.134.384-.398.784-.817.995-1.327.203-.49.212-1.05.22-1.593.008-.563.016-1.152.266-1.4.25-.25.835-.26 1.401-.267.542-.008 1.102-.017 1.593-.22.51-.211.925-.61 1.327-.995.402-.385.813-.778 1.134-.778.321 0 .735.395 1.134.778.398.384.817.784 1.327.995.49.203 1.05.212 1.593.22.563.008 1.152.016 1.4.266.25.25.26.835.267 1.401.008.542.017 1.102.22 1.593.211.51.61.925.995 1.327.384.402.778.813.778 1.134 0 .321-.395.735-.778 1.134zm-3.267-3.517a.641.641 0 010 .91l-4.5 4.5a.643.643 0 01-.91 0l-1.928-1.93a.643.643 0 01.91-.909l1.473 1.475 4.045-4.046a.643.643 0 01.91 0z"
        fill="#000"
      />
    </Svg>
  )
}

const Section = ({
  title,
  details,
  icon,
}: {
  title: string
  details: string
  icon: ReactNode
}) => (
  <Horizontal>
    <Vertical className={"w-10 items-center justify-start"}>{icon}</Vertical>
    <Vertical className={"flex-1"}>
      <H5 color={"default"}>{title}</H5>
      <Body color={"default"} className={"flex-1"}>
        {details}
      </Body>
    </Vertical>
  </Horizontal>
)

export const ApplyAndSubmitSection = () => {
  const { loanApplication } = useLoanContext()
  const isEditable = loanApplication?.status === "Application Started"

  if (!isEditable) {
    return <View className={"mb-3"} />
  }

  return (
    <Vertical className={"p-4 gap-4"}>
      <Vertical>
        <H2 color={"default"}>Ready To Submit?</H2>
        <Body color={"default"}>Your Backflip loan quote...</Body>
      </Vertical>
      <Vertical className={"gap-4"}>
        <Section
          title={"Is non-binding"}
          details={
            "You are under no obligation until terms are finalized between you and our loan expert"
          }
          icon={<BindingIcon />}
        />
        <Section
          title={"Is processed exclusively by Backflip"}
          details={
            "We are your direct lender and will not sell your information to other lenders"
          }
          icon={<ShieldIcon />}
        />
        <Section
          title={"Will not impact your credit score"}
          details={
            "We will not submit a hard credit pull until after terms are finalized"
          }
          icon={<ScoreIcon />}
        />
      </Vertical>

      <View className="my-2">
        <Tiny className="mx-5">
          By clicking submit, you are requesting a quote for Backflip loan
          products, for informational purposes only. After you receive the
          quote, a Backflip representative may contact you concerning our loan
          products. Any rates provided in the quote, or during the call, are
          subject to change and may vary based on data contained in a credit
          report on the principal owner of the entity borrower or the guarantor
          on the loan.
        </Tiny>
      </View>
    </Vertical>
  )
}
